<template>
  <div>
    <LayoutContent>
      <div @mousedown="showWishlistBar = false">
        <SectionTitle :label="$t('label.wishlist')" />
        <button class="d-block ml-auto mb-10" v-if="availableWishlistItems.length > 0" @click="removeAll">{{ $t('label.removeAll') }}</button>
        <div v-if="availableWishlistItems.length"><WishlistItem v-for="item in availableWishlistItems" :item="item" :key="item.wish_id" @addToCart="addCart" /></div>
        <div v-else class="blank-message text-h6 font-weight-medium grey--text text-center">{{ $t('label.emptyWishlist') }}</div>
      </div>
      <div v-if="unavailableWishlistItems.length > 0">
        <SectionTitle :label="$t('label.outOfStock')" />
        <WishlistItem v-for="item in unavailableWishlistItems" :item="item" :key="item.id" />
      </div>
    </LayoutContent>
    <WishlistItemAddedToCartDialog v-model="showAddedToCartDialog" :quantity="addedToCartQuantity" @close="resetCartQuantity" />
    <FailedAddToCartDialog v-model="showFailedAddToCartDialog">{{ failedAddToCartMessage }}</FailedAddToCartDialog>
    <quantity-bar @add-to-cart="addToCartHandler" :quantity="cartQuantity" :min="min" :disabled="outOfStock" v-if="showWishlistBar" />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { localeHelper } from '@/utils'

import LayoutContent from '@/views/layouts/LayoutContent.vue'
import SectionTitle from '@/components/SectionTitle.vue'
import WishlistItem from '@/components/wishlist/WishlistItem.vue'
import WishlistItemAddedToCartDialog from '@/components/wishlist/WishlistItemAddedToCartDialog.vue'
import FailedAddToCartDialog from '@/components/product/FailedAddToCartDialog.vue'
import QuantityBar from '@/components/product/QuantityBar.vue'
import ProductMixin from '@/mixins/product.mixin.js'

export default {
  name: 'WishList',
  mixins: [ProductMixin],
  components: {
    LayoutContent,
    SectionTitle,
    WishlistItem,
    QuantityBar,
    WishlistItemAddedToCartDialog,
    FailedAddToCartDialog
  },
  data: () => ({
    showAddedToCartDialog: false,
    showWishlistBar: false,
    selectedItem: null,
    // cartQuantity: 1
    showFailedAddToCartDialog: false,
    addedToCartQuantity: 0,
    failedAddToCartMessage: ''
  }),

  computed: {
    ...mapState('wishlist', ['wishlist']),
    ...mapState('order', ['shoppingCart']),
    availableWishlistItems() {
      return this.wishlist.length > 0 && this.wishlist.filter((f) => f.stock_status === 'In Stock')
    },
    unavailableWishlistItems() {
      return this.wishlist.length > 0 && this.wishlist.filter((f) => f.stock_status !== 'In Stock')
    },
    outOfStock() {
      return this.selectedItem.stock_status === 'Out of Stock'
    },
    subtractStock() {
      return this.selectedItem.subtract_stock == 1
    },
    cartQuantity: {
      get() {
        return this.min > 1 ? this.min : 1
      },
      set() {}
    },
    shoppingCartQuantity() {
      if (this.shoppingCart.length) {
        let selectedProduct = this.shoppingCart.filter((item) => item.product_id == this.selectedItem.id)
        if (selectedProduct.length) {
          return selectedProduct[0].cart_quantity
        }
      }
      return 0
    },
    min() {
      if (!this.selectedItem) return 0
      return this.shoppingCartQuantity >= this.selectedItem.minimum ? 1 : this.selectedItem.minimum
    }
  },

  created() {
    this.fetchWishlist()
  },

  methods: {
    ...mapActions('wishlist', ['fetchWishlist', 'deleteWishlist']),
    async removeAll() {
      let arr = this.wishlist.map((f) => f.wish_id)
      await this.deleteWishlist(arr)
        .then(() => this.$toast.success(localeHelper.getMessage('message.removeItemSuccessfully')))
        .catch((err) => {
          this.$toast.error(localeHelper.getMessage('message.removeItemFailed'))
        })
    },
    addCart(item) {
      this.showWishlistBar = true
      this.selectedItem = item
    },
    addToCartHandler(quantity) {
      if (this.selectedItem.limit_per_order && this.shoppingCartQuantity + quantity > this.selectedItem.limit_per_order) {
        this.showFailedAddToCartDialog = true
        const quantity = this.selectedItem.limit_per_order - this.shoppingCartQuantity
        this.failedAddToCartMessage = localeHelper.getMessage('message.remainingCartQuantityToAdd', { quantity })
        return
      }
      if (this.subtractStock && this.shoppingCartQuantity + quantity > this.selectedItem.quantity) {
        this.showFailedAddToCartDialog = true
        const quantity = this.selectedItem.quantity
        this.failedAddToCartMessage = localeHelper.getMessage('message.cartStockLimit', { quantity })
        return
      }
      this.cartQuantity = quantity
      this.addedToCartQuantity = quantity
      let body = {
        product_id: this.selectedItem.id,
        quantity: quantity,
        is_checked: 0
      }
      if (this.selectedItem.volume_variation === 1) Object.assign(body, { product_volume_variation_id: this.selectedItem.product_volume_variation_id })
      let requestBody = { products: [body] }
      this.addToCart(requestBody)
      this.showWishlistBar = false
      this.showAddedToCartDialog = true
    },
    resetCartQuantity() {
      this.cartQuantity = 1
    }
  }
}
</script>
<style lang="scss" scoped>
.blank-message {
  margin: 150px;
}
</style>
